/* THIS FILE IS AUTO-GENERATED – DO NOT EDIT */

import {forwardRef, type ForwardRefExoticComponent, type RefAttributes, type SVGProps} from 'react'

/**
 * @public
 */
export const PauseIcon: ForwardRefExoticComponent<
  Omit<SVGProps<SVGSVGElement>, 'ref'> & RefAttributes<SVGSVGElement>
> = /* @__PURE__ */ forwardRef(function PauseIcon(props, ref) {
  return (
    <svg
      data-sanity-icon="pause"
      width="1em"
      height="1em"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path d="M10.5 7.5H8.5V17.5H10.5V7.5Z" fill="currentColor" />
      <path d="M16.5 7.5H14.5V17.5H16.5V7.5Z" fill="currentColor" />
      <path d="M10.5 7.5H8.5V17.5H10.5V7.5Z" stroke="currentColor" strokeWidth={1.2} />
      <path d="M16.5 7.5H14.5V17.5H16.5V7.5Z" stroke="currentColor" strokeWidth={1.2} />
    </svg>
  )
})

export {PauseIcon as default}
